import React, { FC } from 'react';
import { TableLink } from 'src/components/TableLink';

type ProductNameLinkProps = {
    productId?: number;
    name?: string;
};

const ProductNameLink: FC<ProductNameLinkProps> = ({ productId, name }) => {
    if (!productId) {
        return <>{name}</>;
    }

    return (
        <TableLink href={`/products/${productId}`} target="_blank" rel="noopener noreferrer">
            {name}
        </TableLink>
    );
};

export default ProductNameLink;
